module.exports = __webpack_public_path__ + "img/05068e3.svg";